module.exports = __webpack_public_path__ + "static/media/afgewerkt.cd0edc9e.svg";